export type WallpaperPosition = 'center' | 'tile' | 'stretch';

export interface Wallpaper {
  id: string;
  name: string;
  /** Path under /public. */
  src: string;
  /**
   * Fallback colour painted behind the image: the image's own average, so a
   * Centre or Tile that doesn't reach the edges is bordered by something the
   * photograph actually contains rather than by a flat blue.
   */
  backdrop: string;
  defaultPosition: WallpaperPosition;
}

/**
 * The shipped wallpapers, in the order Display Properties lists them. Every
 * one is the genuine XP article at 1920 wide, so they are heavy (0.7–1.5 MB)
 * and deliberately *not* preloaded — only `bliss` is warmed in `index.html`,
 * and the rest are fetched the first time they are selected.
 */
export const wallpapers: Wallpaper[] = [
  {
    id: 'bliss',
    name: 'Bliss',
    src: '/assets/wallpapers/bliss.webp',
    backdrop: '#628595',
    defaultPosition: 'stretch',
  },
  {
    id: 'autumn',
    name: 'Autumn',
    src: '/assets/wallpapers/autumn.jpg',
    backdrop: '#89561d',
    defaultPosition: 'stretch',
  },
  {
    id: 'follow',
    name: 'Follow',
    src: '/assets/wallpapers/follow.jpg',
    backdrop: '#346faa',
    defaultPosition: 'stretch',
  },
  {
    id: 'moon-flower',
    name: 'Moon Flower',
    src: '/assets/wallpapers/moon-flower.jpg',
    backdrop: '#c1185d',
    defaultPosition: 'stretch',
  },
  {
    id: 'tulips',
    name: 'Tulips',
    src: '/assets/wallpapers/tulips.jpg',
    backdrop: '#8e876d',
    defaultPosition: 'stretch',
  },
  {
    id: 'wind',
    name: 'Wind',
    src: '/assets/wallpapers/wind.jpg',
    backdrop: '#bd8875',
    defaultPosition: 'stretch',
  },
  {
    id: 'none',
    name: '(None)',
    src: '',
    backdrop: '#3a6ea5',
    defaultPosition: 'stretch',
  },
];

export const DEFAULT_WALLPAPER = 'bliss';

export function findWallpaper(id: string): Wallpaper {
  return wallpapers.find((w) => w.id === id) ?? wallpapers[0]!;
}
